import React from 'react';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import ListTemplate from '../../../Reusable_Components/ListTemplate';

const QuoteCommentListDetails = ({ quoteId }) => {
  const columns = [
    { label: 'Quote', value: 'quote.quote_number' },
    { label: 'User', value: 'user.username' },
    { label: 'Comment Text', value: 'text' },
  ];

  return (
    <div>
      <h1>Quote Comments</h1>
      <ListTemplate columns={columns} fetchUrl={`${API_DOMAIN}${API_ROUTES.quoteComments}?quote=${quoteId}`} />
    </div>
  );
};

export default QuoteCommentListDetails;
